(function () {
  var root = document.querySelector('.tm-rotation');

  if (!root) {
    return;
  }

  var SELECTORS = {
    scrollTrigger: '[data-tm-rotation-scroll-to]',
    anchorLink: '[data-tm-rotation-anchor-link]',
    stickyOffset: '[data-tm-rotation-sticky-offset]',
    drawer: '[data-tm-rotation-drawer]',
    drawerOpen: '[data-tm-rotation-drawer-open]',
    drawerClose: '[data-tm-rotation-drawer-close]',
    addRotation: '[data-tm-rotation-add-rotation]',
    editRotation: '[data-tm-rotation-edit-rotation]',
    presetCard: '[data-tm-rotation-preset-card]',
    r03Builder: '[data-tm-rotation-r03-builder]',
    r03Card: '[data-tm-rotation-r03-card]',
    r03Toggle: '[data-tm-rotation-r03-toggle]',
    r03Details: '[data-tm-rotation-r03-details]',
    r03Filter: '[data-tm-rotation-r03-filter]',
    r03Add: '[data-tm-rotation-r03-add]',
    r03MobileReview: '[data-tm-rotation-r03-mobile-review]',
    r03MobileSummary: '[data-tm-rotation-r03-mobile-summary]',
    r03MobileDrawer: '[data-tm-rotation-r03-mobile-drawer]',
    r03MobileDrawerClose: '[data-tm-rotation-r03-mobile-drawer-close]',
    r04Finder: '[data-tm-rotation-r04-moment-finder]',
    r04Tab: '[data-tm-rotation-r04-tab]',
    r04Panel: '[data-tm-rotation-r04-panel]',
    r04Cta: '[data-tm-rotation-r04-cta]',
    r05Focus: '[data-tm-rotation-r05-seasonal-focus]',
    r05Trigger: '[data-tm-rotation-r05-trigger]',
    r05Card: '[data-tm-rotation-r05-card]',
    r05Scroller: '[data-tm-rotation-r05-scroller]',
    r05Prev: '[data-tm-rotation-r05-prev]',
    r05Next: '[data-tm-rotation-r05-next]',
    r05Dot: '[data-tm-rotation-r05-dot]',
    r06WhyRotation: '[data-tm-rotation-r06-why-rotation]',
    r06Cta: '[data-tm-rotation-r06-cta]',
    r07SavingsExplainer: '[data-tm-rotation-r07-savings-explainer]',
    r07Cta: '[data-tm-rotation-r07-cta]',
    r08ProofReviews: '[data-tm-rotation-r08-proof-reviews]',
    r08Cta: '[data-tm-rotation-r08-cta]',
    r09Faq: '[data-tm-rotation-r09-faq]',
    r09Cta: '[data-tm-rotation-r09-cta]',
    r09Item: '[data-tm-rotation-r09-item]',
    r09Trigger: '[data-tm-rotation-r09-trigger]',
    r09Panel: '[data-tm-rotation-r09-panel]',
    r10FinalCta: '[data-tm-rotation-r10-final-cta]',
    r10Cta: '[data-tm-rotation-r10-cta]',
    r10Sticky: '[data-tm-rotation-r10-sticky]',
    r10StickyTrigger: '[data-tm-rotation-r10-sticky-trigger]'
  };

  function isBuildRotationView() {
    if (!window.location || window.location.pathname !== '/pages/build-your-rotation') {
      return false;
    }

    try {
      return new URLSearchParams(window.location.search || '').get('view') === 'tm-rotation';
    } catch (error) {
      return /(?:^|[?&])view=tm-rotation(?:&|$)/.test(window.location.search || '');
    }
  }

  function markRotationContext() {
    document.documentElement.setAttribute('data-tm-rotation-context', 'true');
    document.dispatchEvent(new CustomEvent('tm-rotation:context', {
      bubbles: true,
      detail: {
        active: true
      }
    }));
  }

  if (isBuildRotationView()) {
    markRotationContext();
  }

  function requestFrame(callback) {
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(callback);
      return;
    }

    window.setTimeout(callback, 16);
  }

  function getTargetSelector(trigger) {
    return trigger.getAttribute('data-tm-rotation-scroll-to') || trigger.getAttribute('href') || '';
  }

  function normalizeHash(value) {
    if (!value) {
      return '';
    }

    var hashIndex = value.indexOf('#');

    return hashIndex >= 0 ? value.slice(hashIndex) : value;
  }

  function getStickyOffset() {
    var offset = 0;
    var stickyItems = document.querySelectorAll(SELECTORS.stickyOffset);

    stickyItems.forEach(function (item) {
      var styles = window.getComputedStyle(item);
      var rect = item.getBoundingClientRect();
      var isSticky = styles.position === 'sticky' || styles.position === 'fixed';

      if (isSticky && rect.width > 0 && rect.height > 0) {
        offset += rect.height;
      }
    });

    return offset;
  }

  function findBySelector(selector) {
    if (!selector) {
      return null;
    }

    try {
      return document.querySelector(selector);
    } catch (error) {
      return null;
    }
  }

  function scrollToHash(hash, updateHistory, behavior) {
    var selector = normalizeHash(hash);

    if (!selector) {
      return false;
    }

    var target = findBySelector(selector);

    if (!target) {
      return false;
    }

    var top = target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset() - 12;

    window.scrollTo({
      top: Math.max(0, top),
      behavior: behavior || 'smooth'
    });

    if (updateHistory && selector.charAt(0) === '#' && window.history && window.history.pushState) {
      window.history.pushState(null, '', selector);
    }

    return true;
  }

  function handoffToRotationTarget(targetSelector, filter, behavior) {
    var targetHash = normalizeHash(targetSelector);

    if (!targetHash) {
      return false;
    }

    if (filter) {
      document.dispatchEvent(new CustomEvent('tm-rotation:activate-filter', {
        detail: {
          filter: filter,
          targetSelector: targetHash
        }
      }));
    }

    return scrollToHash(targetHash, false, behavior);
  }

  function isStickyElementVisible(element) {
    if (!element || element.hidden) {
      return false;
    }

    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return styles.display !== 'none' && styles.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function isRectInViewportRange(rect, before, after) {
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    return rect.bottom > -after && rect.top < viewportHeight + before;
  }

  function isOfficialCartSurfaceOpen() {
    var pathname = window.location && window.location.pathname ? window.location.pathname : '';
    var rootClasses = [
      document.documentElement.className || '',
      document.body ? document.body.className || '' : ''
    ].join(' ');
    var cartStatePattern = /\b(js-drawer-open|drawer-open|cart-open|cart-drawer-open|cart-drawer-is-open|ajaxcart-open|no-scroll|overflow-hidden)\b/i;

    if (pathname === '/cart' || pathname.indexOf('/cart/') === 0) {
      return true;
    }

    if (cartStatePattern.test(rootClasses)) {
      return true;
    }

    var cartSurfaces = document.querySelectorAll(
      '#CartDrawer, [data-cart-drawer], .cart-drawer, .drawer--right, .ajaxcart, .rebuy-cart'
    );

    for (var i = 0; i < cartSurfaces.length; i += 1) {
      var surface = cartSurfaces[i];
      var surfaceClasses = surface.className || '';
      var surfaceOpenByState = /\b(is-open|active|open|drawer--is-open|cart-drawer--active)\b/i.test(surfaceClasses) || surface.getAttribute('aria-hidden') === 'false';

      if (surfaceOpenByState && isStickyElementVisible(surface)) {
        return true;
      }
    }

    var overlays = document.querySelectorAll(
      '.drawer__overlay, .drawer-overlay, .cart-drawer__overlay, .ajaxcart__overlay, .modal__overlay, [data-cart-overlay], [data-drawer-overlay]'
    );

    for (var j = 0; j < overlays.length; j += 1) {
      var overlay = overlays[j];
      var overlayClasses = overlay.className || '';
      var overlayOpenByState = /\b(is-open|active|open|visible)\b/i.test(overlayClasses) || overlay.getAttribute('aria-hidden') === 'false';

      if (overlayOpenByState && isStickyElementVisible(overlay)) {
        return true;
      }
    }

    return false;
  }

  function openCartDrawer() {
    document.dispatchEvent(new CustomEvent('cart:open'));

    var cartTrigger = document.querySelector(
      '[data-rebuy-open-cart], [data-rebuy-cart-toggle], .rebuy-cart__toggle, [data-cart-drawer-open], [data-open-cart], .js-drawer-open-cart, .cart-toggle, .header__icon--cart, button[aria-controls="CartDrawer"], a[aria-controls="CartDrawer"], #cart-icon-bubble'
    );

    if (cartTrigger && typeof cartTrigger.click === 'function') {
      cartTrigger.click();
      return true;
    }

    return false;
  }

  function updateActiveLinks(activeHash) {
    if (!activeHash) {
      return;
    }

    document.querySelectorAll(SELECTORS.anchorLink).forEach(function (link) {
      var linkHash = normalizeHash(getTargetSelector(link));
      var isActive = linkHash === activeHash;

      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function refreshActiveFromScroll() {
    var links = Array.prototype.slice.call(document.querySelectorAll(SELECTORS.anchorLink));
    var targets = links
      .map(function (link) {
        var hash = normalizeHash(getTargetSelector(link));
        var section = hash ? document.querySelector(hash) : null;

        return section ? { hash: hash, section: section } : null;
      })
      .filter(Boolean);

    if (!targets.length) {
      return;
    }

    var offset = getStickyOffset() + 24;
    var active = targets[0].hash;

    targets.forEach(function (item) {
      if (item.section.getBoundingClientRect().top <= offset) {
        active = item.hash;
      }
    });

    updateActiveLinks(active);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(SELECTORS.scrollTrigger);

    if (!trigger) {
      return;
    }

    var target = getTargetSelector(trigger);
    var targetHash = normalizeHash(target);
    var isSamePage = targetHash && (target === targetHash || target.indexOf(window.location.pathname + '#') >= 0);

    if (!isSamePage && target.indexOf('#') > 0) {
      return;
    }

    if (scrollToHash(targetHash, true)) {
      event.preventDefault();
      updateActiveLinks(targetHash);
    }
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(SELECTORS.addRotation);

    if (!trigger) {
      return;
    }

    var card = trigger.closest(SELECTORS.presetCard);

    if (!card) {
      return;
    }

    event.preventDefault();

    var cardGroup = card.parentElement;
    var variantIds = (card.getAttribute('data-tm-rotation-variant-ids') || '')
      .split(',')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);
    var missingHandles = card.getAttribute('data-tm-rotation-missing-handles') || '';
    var unavailableProducts = card.getAttribute('data-tm-rotation-unavailable-products') || '';
    var feedback = card.querySelector('[data-tm-rotation-card-feedback]');
    var loadingLabel = trigger.getAttribute('data-tm-rotation-loading-label') || 'Adding...';
    var successLabel = trigger.getAttribute('data-tm-rotation-success-label') || 'Added';
    var unavailableLabel = trigger.getAttribute('data-tm-rotation-unavailable-label') || 'Unavailable';

    markRotationContext();

    if (!trigger.dataset.originalLabel) {
      trigger.dataset.originalLabel = trigger.textContent.trim();
    }

    function setFeedback(message) {
      if (!feedback) {
        return;
      }

      feedback.textContent = message || '';
      feedback.hidden = !message;
    }

    function setSelected() {
      if (cardGroup) {
        cardGroup.querySelectorAll(SELECTORS.presetCard).forEach(function (item) {
          var button = item.querySelector(SELECTORS.addRotation);

          item.classList.toggle('is-selected', item === card);

          if (button) {
            button.setAttribute('aria-pressed', item === card ? 'true' : 'false');

            if (item === card) {
              button.textContent = successLabel;
            } else if (button.dataset.originalLabel) {
              button.textContent = button.dataset.originalLabel;
            }
          }
        });
      }
    }

    function openCart() {
      document.dispatchEvent(new CustomEvent('cart:open'));

      var cartTrigger = document.querySelector(
        '[data-rebuy-open-cart], [data-rebuy-cart-toggle], .rebuy-cart__toggle, [data-cart-drawer-open], [data-open-cart], .js-drawer-open-cart, .cart-toggle, .header__icon--cart, button[aria-controls="CartDrawer"], a[aria-controls="CartDrawer"], #cart-icon-bubble'
      );

      if (cartTrigger && typeof cartTrigger.click === 'function') {
        cartTrigger.click();
        return true;
      }

      return false;
    }

    if (!variantIds.length) {
      trigger.textContent = unavailableLabel;
      setFeedback('This rotation is currently unavailable.');
      return;
    }

    trigger.disabled = true;
    trigger.setAttribute('aria-busy', 'true');
    trigger.textContent = loadingLabel;
    setFeedback('');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: variantIds.map(function (id) {
          return {
            id: Number(id),
            quantity: 1
          };
        })
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () {
            return {};
          }).then(function (payload) {
            throw new Error(payload.description || payload.message || 'Unable to add this rotation.');
          });
        }

        return response.json();
      })
      .then(function (addResponse) {
        return fetch('/cart.js', {
          headers: {
            'Accept': 'application/json'
          }
        }).then(function (response) {
          if (!response.ok) {
            return addResponse;
          }

          return response.json();
        });
      })
      .then(function (cart) {
        setSelected();

        if (missingHandles || unavailableProducts) {
          setFeedback('Added available products. Unavailable: ' + [missingHandles, unavailableProducts].filter(Boolean).join(', '));
        }

        try {
          window.sessionStorage.setItem('tmRotationSelectedPreset', JSON.stringify({
            id: card.getAttribute('data-tm-rotation-preset-id') || '',
            title: card.getAttribute('data-tm-rotation-preset-title') || '',
            variantIds: variantIds
          }));
        } catch (error) {
          // Storage can be unavailable in some privacy modes; cart add still succeeds.
        }

        document.dispatchEvent(new CustomEvent('product-form:cart:update', {
          bubbles: true,
          detail: {
            cart: cart
          }
        }));

        card.dispatchEvent(new CustomEvent('tm-rotation:recommended-rotation:add', {
          bubbles: true,
          detail: {
            id: card.getAttribute('data-tm-rotation-preset-id') || '',
            title: card.getAttribute('data-tm-rotation-preset-title') || '',
            variantIds: variantIds,
            cart: cart
          }
        }));

        if (!openCart()) {
          window.location.href = '/cart';
        }
      })
      .catch(function (error) {
        trigger.textContent = trigger.dataset.originalLabel || trigger.textContent;
        setFeedback(error.message || 'Unable to add this rotation.');
      })
      .finally(function () {
        trigger.disabled = false;
        trigger.removeAttribute('aria-busy');
      });
  });

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest(SELECTORS.editRotation);

    if (!trigger) {
      return;
    }

    var card = trigger.closest(SELECTORS.presetCard);

    if (!card) {
      return;
    }

    markRotationContext();

    card.dispatchEvent(new CustomEvent('tm-rotation:edit-rotation', {
      bubbles: true,
      detail: {
        id: card.getAttribute('data-tm-rotation-preset-id') || '',
        title: card.getAttribute('data-tm-rotation-preset-title') || '',
        variantIds: (card.getAttribute('data-tm-rotation-variant-ids') || '').split(',').filter(Boolean),
        handles: (card.getAttribute('data-tm-rotation-handles') || '')
          .split(',')
          .map(function (handle) {
            return handle.trim();
          })
          .filter(Boolean)
      }
    }));
  });

  function initR03Builder(builder) {
    var min = Number(builder.getAttribute('data-tm-rotation-min')) || 2;
    var topTier = 5;
    var selectionLimit = Number(builder.getAttribute('data-tm-rotation-max')) || 0;
    var emptyLabel = builder.getAttribute('data-tm-rotation-empty-label') || 'Choose at least 2 scents';
    var oneLabel = builder.getAttribute('data-tm-rotation-one-label') || 'Add 1 more scent';
    var completeHelper = builder.getAttribute('data-tm-rotation-complete-helper') || '18% unlocked. Your rotation qualifies for the highest savings tier.';
    var addToRotationLabel = builder.getAttribute('data-tm-rotation-add-to-rotation-label') || 'Add to rotation';
    var removeLabel = builder.getAttribute('data-tm-rotation-remove-label') || 'Remove';
    var removeFromRotationLabel = builder.getAttribute('data-tm-rotation-remove-from-rotation-label') || 'Remove from rotation';
    var activeCtaFormat = builder.getAttribute('data-tm-rotation-active-cta-format') || 'Add [count]-scent rotation';
    var viewProductLabel = builder.getAttribute('data-tm-rotation-view-product-label') || 'View product';
    var showCardPrice = builder.getAttribute('data-tm-rotation-show-card-price') !== 'false';
    var showCardVariant = builder.getAttribute('data-tm-rotation-show-card-variant') !== 'false';
    var showModalPrice = builder.getAttribute('data-tm-rotation-show-modal-price') !== 'false';
    var showModalVariant = builder.getAttribute('data-tm-rotation-show-modal-variant') !== 'false';
    var showViewProduct = builder.getAttribute('data-tm-rotation-show-view-product') !== 'false';
    var showSelectedThumbnails = builder.getAttribute('data-tm-rotation-show-selected-thumbnails') !== 'false';
    var showSelectedVariant = builder.getAttribute('data-tm-rotation-show-selected-variant') !== 'false';
    var showSelectedPrice = builder.getAttribute('data-tm-rotation-show-selected-price') !== 'false';
    var cards = Array.prototype.slice.call(builder.querySelectorAll(SELECTORS.r03Card));
    var selected = [];
    var isAdding = false;
    var activeModalCard = null;
    var lastFocused = null;
    var modal = builder.querySelector('[data-tm-rotation-r03-modal]');
    var modalPanel = modal && modal.querySelector('.tm-rotation-r03-builder__modal-panel');
    var modalToggle = modal && modal.querySelector('[data-tm-rotation-r03-modal-toggle]');
    var mobileDrawer = builder.querySelector(SELECTORS.r03MobileDrawer);
    var mobileDrawerPanel = mobileDrawer && mobileDrawer.querySelector('.tm-rotation-r03-builder__mobile-drawer-panel');
    var mobileDrawerLastFocused = null;
    var activeFilter = 'all';
    var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function splitList(value) {
      return (value || '')
        .split(',')
        .map(function (item) {
          return item.trim();
        })
        .filter(Boolean);
    }

    function normalize(value) {
      return (value || '').trim().toLowerCase();
    }

    function normalizeProfileText(value) {
      return (value || '')
        .replace(/\s*\+\s*/g, ' • ')
        .replace(/\s*•\s*/g, ' • ')
        .trim();
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function readVariants(card) {
      if (card._tmRotationVariants) {
        return card._tmRotationVariants;
      }

      var source = card.querySelector('[data-tm-rotation-r03-variants-json]');
      var variants = [];

      if (source && source.textContent) {
        try {
          variants = JSON.parse(source.textContent).filter(function (variant) {
            return variant && variant.id;
          });
        } catch (error) {
          variants = [];
        }
      }

      card._tmRotationVariants = variants;
      return variants;
    }

    function getAvailableVariants(card) {
      return readVariants(card).filter(function (variant) {
        return variant.available;
      });
    }

    function normalizeVariantTitle(value) {
      return normalize(value).replace(/\s+/g, '').replace(/milliliters?/g, 'ml');
    }

    function isMeaningfulVariantTitle(title) {
      return !!title && normalize(title) !== 'default title';
    }

    function getVariantPriority(variant) {
      var title = normalizeVariantTitle(variant.title);
      var priorities = ['30ml', '50ml', '10ml', '100ml'];
      var index = priorities.findIndex(function (size) {
        return title.indexOf(size) !== -1;
      });

      return index === -1 ? priorities.length : index;
    }

    function getDefaultVariant(card) {
      var available = getAvailableVariants(card);

      if (!available.length) {
        return null;
      }

      return available.slice().sort(function (a, b) {
        var priorityDiff = getVariantPriority(a) - getVariantPriority(b);

        if (priorityDiff !== 0) {
          return priorityDiff;
        }

        return readVariants(card).indexOf(a) - readVariants(card).indexOf(b);
      })[0];
    }

    function findVariant(card, variantId) {
      var variants = readVariants(card);
      var id = String(variantId || '');

      return variants.find(function (variant) {
        return String(variant.id) === id;
      }) || null;
    }

    function getCurrentVariant(card) {
      return findVariant(card, card.getAttribute('data-tm-rotation-variant-id')) || getDefaultVariant(card);
    }

    function getScentKey(data) {
      return data.handle || data.title;
    }

    function selectedKey(data) {
      return getScentKey(data);
    }

    function getSelectedItemForCard(card) {
      var data = getCardData(card);
      var key = selectedKey(data);

      return selected.find(function (item) {
        return selectedKey(item) === key;
      }) || null;
    }

    function setCardVariant(card, variantId) {
      var variant = findVariant(card, variantId) || getDefaultVariant(card);
      var row = card.querySelector('[data-tm-rotation-r03-variant-row]');
      var select = card.querySelector('[data-tm-rotation-r03-variant-select]');
      var label = card.querySelector('[data-tm-rotation-r03-variant-label]');
      var price = card.querySelector('[data-tm-rotation-r03-variant-price]');
      var available = getAvailableVariants(card);
      var meaningfulTitle = variant && isMeaningfulVariantTitle(variant.title) ? variant.title : '';

      if (!variant) {
        if (row) {
          row.hidden = true;
        }
        return;
      }

      card.setAttribute('data-tm-rotation-variant-id', variant.id);
      card.setAttribute('data-tm-rotation-scent-variant-title', meaningfulTitle);
      card.setAttribute('data-tm-rotation-scent-price', variant.formattedPrice || '');
      card.setAttribute('data-tm-rotation-scent-variant-image', variant.image || '');
      card.setAttribute('data-tm-rotation-scent-variant-modal-image', variant.modalImage || '');

      if (row) {
        row.hidden = !showCardPrice && !showCardVariant;
      }

      if (price) {
        price.textContent = variant.formattedPrice || '';
        price.hidden = !showCardPrice || !variant.formattedPrice;
      }

      if (select) {
        select.innerHTML = '';

        available.forEach(function (item) {
          var option = document.createElement('option');
          option.value = item.id;
          option.textContent = isMeaningfulVariantTitle(item.title) ? item.title : 'Default';
          option.disabled = !item.available;
          option.selected = String(item.id) === String(variant.id);
          select.appendChild(option);
        });

        select.hidden = !showCardVariant || available.length <= 1;
      }

      if (label) {
        label.textContent = meaningfulTitle;
        label.hidden = !showCardVariant || available.length > 1 || !meaningfulTitle;
      }
    }

    function initializeVariantControls() {
      cards.forEach(function (card) {
        setCardVariant(card, card.getAttribute('data-tm-rotation-variant-id'));
      });
    }

    function getCardData(card) {
      var variant = getCurrentVariant(card);
      var variantTitle = variant && isMeaningfulVariantTitle(variant.title) ? variant.title : '';
      var price = variant && variant.formattedPrice ? variant.formattedPrice : card.getAttribute('data-tm-rotation-scent-price') || '';
      var variantImage = variant && variant.image ? variant.image : '';
      var variantModalImage = variant && variant.modalImage ? variant.modalImage : '';

      return {
        card: card,
        handle: card.getAttribute('data-tm-rotation-scent-handle') || '',
        title: card.getAttribute('data-tm-rotation-scent-title') || '',
        role: card.getAttribute('data-tm-rotation-scent-role') || '',
        tags: splitList(card.getAttribute('data-tm-rotation-scent-tags')),
        notes: normalizeProfileText(card.getAttribute('data-tm-rotation-scent-notes') || ''),
        detailTitle: card.getAttribute('data-tm-rotation-scent-detail-title') || card.getAttribute('data-tm-rotation-scent-title') || '',
        detailCopy: card.getAttribute('data-tm-rotation-scent-detail-copy') || '',
        bestFor: card.getAttribute('data-tm-rotation-scent-best-for') || '',
        modalEyebrow: card.getAttribute('data-tm-rotation-scent-modal-eyebrow') || '',
        modalProfile: normalizeProfileText(card.getAttribute('data-tm-rotation-scent-modal-profile') || ''),
        modalLead: card.getAttribute('data-tm-rotation-scent-modal-lead') || '',
        modalSmellsLike: card.getAttribute('data-tm-rotation-scent-modal-smells-like') || '',
        modalSkinPerformance: card.getAttribute('data-tm-rotation-scent-modal-skin-performance') || '',
        modalClothesPerformance: card.getAttribute('data-tm-rotation-scent-modal-clothes-performance') || '',
        modalProjection: card.getAttribute('data-tm-rotation-scent-modal-projection') || '',
        modalTopNotes: card.getAttribute('data-tm-rotation-scent-modal-top-notes') || '',
        modalMiddleNotes: card.getAttribute('data-tm-rotation-scent-modal-middle-notes') || '',
        modalBaseNotes: card.getAttribute('data-tm-rotation-scent-modal-base-notes') || '',
        modalBestWorn: card.getAttribute('data-tm-rotation-scent-modal-best-worn') || '',
        modalBestForChips: splitList(card.getAttribute('data-tm-rotation-scent-modal-best-for-chips') || ''),
        variants: readVariants(card),
        variantTitle: variantTitle,
        price: price,
        productUrl: card.getAttribute('data-tm-rotation-scent-url') || '',
        variantId: variant ? String(variant.id) : card.getAttribute('data-tm-rotation-variant-id') || '',
        image: variantImage || card.getAttribute('data-tm-rotation-scent-image') || '',
        mobileImage: variantImage || card.getAttribute('data-tm-rotation-scent-mobile-image') || card.getAttribute('data-tm-rotation-scent-image') || '',
        modalImage: variantModalImage || card.getAttribute('data-tm-rotation-scent-modal-image') || '',
        mobileModalImage: variantModalImage || card.getAttribute('data-tm-rotation-scent-mobile-modal-image') || ''
      };
    }

    function isSelected(card) {
      var data = getCardData(card);
      var key = selectedKey(data);

      return selected.some(function (item) {
        return selectedKey(item) === key;
      });
    }

    function getTierMessage(count) {
      if (count <= 0) {
        return 'Choose 2 scents to unlock 10% off.';
      }

      if (count === 1) {
        return 'Add 1 more scent to unlock 10% off.';
      }

      if (count === 2) {
        return '10% unlocked. Add 1 more scent to unlock 13% off.';
      }

      if (count === 3) {
        return '13% unlocked. Add 2 more scents to unlock 18% off.';
      }

      if (count === 4) {
        return '13% unlocked. Add 1 more scent to unlock 18% off.';
      }

      return '18% unlocked. Your rotation qualifies for the highest savings tier.';
    }

    function getActiveAddLabel(count) {
      return activeCtaFormat
        .replace(/\{\{\s*count\s*\}\}/g, count)
        .replace(/\[count\]/g, count);
    }

    function getCtaLabel(count) {
      if (count <= 0) {
        return emptyLabel;
      }

      if (count === 1) {
        return oneLabel;
      }

      return getActiveAddLabel(count);
    }

    function getMobileReviewLabel(count) {
      if (count >= min) {
        return 'Review ' + count + '-scent rotation';
      }

      return getCtaLabel(count);
    }

    function setTextAll(selector, text) {
      builder.querySelectorAll(selector).forEach(function (item) {
        item.textContent = text;
      });
    }

    function setError(message) {
      builder.querySelectorAll('[data-tm-rotation-r03-error]').forEach(function (item) {
        item.textContent = message || '';
        item.hidden = !message;
      });
    }

    function createSelectedThumb(item, mobile) {
      var frame = document.createElement('span');
      frame.className = mobile
        ? 'tm-rotation-r03-builder__mobile-chip-image'
        : 'tm-rotation-r03-builder__selected-image';

      var imageUrl = mobile ? item.mobileImage || item.image : item.image || item.mobileImage;

      if (imageUrl) {
        var image = document.createElement('img');
        image.src = imageUrl;
        image.alt = '';
        image.loading = 'lazy';
        image.decoding = 'async';
        frame.appendChild(image);
      } else {
        var fallback = document.createElement('span');
        fallback.textContent = (item.title || '?').slice(0, 1).toUpperCase();
        frame.appendChild(fallback);
      }

      return frame;
    }

    function renderSelectedList() {
      var list = builder.querySelector('[data-tm-rotation-r03-list]');

      if (!list) {
        return;
      }

      list.innerHTML = '';

      if (!selected.length) {
        var empty = document.createElement('li');
        empty.className = 'tm-rotation-r03-builder__selected-empty';
        empty.textContent = 'No scents selected yet.';
        list.appendChild(empty);
        return;
      }

      selected.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'tm-rotation-r03-builder__selected-item';

        var copy = document.createElement('span');
        copy.className = 'tm-rotation-r03-builder__selected-copy';

        var name = document.createElement('span');
        name.className = 'tm-rotation-r03-builder__selected-name';
        name.textContent = item.title;

        copy.appendChild(name);

        var metaParts = [];
        if (showSelectedVariant && item.variantTitle) {
          metaParts.push(item.variantTitle);
        }
        if (showSelectedPrice && item.price) {
          metaParts.push(item.price);
        }

        if (metaParts.length) {
          var meta = document.createElement('span');
          meta.className = 'tm-rotation-r03-builder__selected-meta';
          meta.textContent = metaParts.join(' • ');
          copy.appendChild(meta);
        }

        if (item.notes) {
          var notes = document.createElement('span');
          notes.className = 'tm-rotation-r03-builder__selected-notes';
          notes.textContent = item.notes;
          copy.appendChild(notes);
        }

        var body = document.createElement('span');
        body.className = 'tm-rotation-r03-builder__selected-body';
        if (showSelectedThumbnails) {
          body.appendChild(createSelectedThumb(item, false));
        }
        body.appendChild(copy);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = removeLabel;
        remove.setAttribute('data-tm-rotation-r03-remove', selectedKey(item));
        remove.setAttribute('aria-label', removeLabel + ' ' + item.title);

        li.appendChild(body);
        li.appendChild(remove);
        list.appendChild(li);
      });
    }

    function renderSelectedChips() {
      var lists = builder.querySelectorAll('[data-tm-rotation-r03-chip-list]');

      lists.forEach(function (list) {
        list.innerHTML = '';

        if (!selected.length) {
          var empty = document.createElement('span');
          empty.className = 'tm-rotation-r03-builder__mobile-chip-empty';
          empty.textContent = 'No scents selected yet.';
          list.appendChild(empty);
          return;
        }

        selected.forEach(function (item) {
          var chip = document.createElement('span');
          chip.className = 'tm-rotation-r03-builder__mobile-chip';

          if (showSelectedThumbnails) {
            chip.appendChild(createSelectedThumb(item, true));
          }

          var row = document.createElement('span');
          row.className = 'tm-rotation-r03-builder__mobile-chip-row';

          var text = document.createElement('span');
          text.className = 'tm-rotation-r03-builder__mobile-chip-name';
          text.textContent = item.title;

          var variant = document.createElement('span');
          variant.className = 'tm-rotation-r03-builder__mobile-chip-variant';
          variant.textContent = item.variantTitle || '';
          variant.hidden = !showSelectedVariant || !item.variantTitle;

          var remove = document.createElement('button');
          remove.type = 'button';
          remove.textContent = 'x';
          remove.setAttribute('data-tm-rotation-r03-remove', selectedKey(item));
          remove.setAttribute('aria-label', 'Remove ' + item.title);

          row.appendChild(text);
          row.appendChild(variant);
          row.appendChild(remove);
          chip.appendChild(row);
          list.appendChild(chip);
        });
      });
    }

    function updateModalCta() {
      if (!modalToggle || !activeModalCard) {
        return;
      }

      var selectedCard = isSelected(activeModalCard);
      var disabled = activeModalCard.classList.contains('is-disabled');

      modalToggle.textContent = selectedCard ? removeFromRotationLabel : addToRotationLabel;
      modalToggle.disabled = disabled;
      modalToggle.setAttribute('aria-pressed', selectedCard ? 'true' : 'false');
    }

    function sameCleanText(a, b) {
      return normalize(a).replace(/\s+/g, ' ') === normalize(b).replace(/\s+/g, ' ');
    }

    function setModalText(selector, text) {
      var element = modal && modal.querySelector(selector);

      if (!element) {
        return;
      }

      element.textContent = text || '';
      element.hidden = !text;
    }

    function setModalSection(name, text) {
      var section = modal && modal.querySelector('[data-tm-rotation-r03-modal-section="' + name + '"]');

      if (!section) {
        return;
      }

      var body = section.querySelector('p');

      if (body) {
        body.textContent = text || '';
      }

      section.hidden = !text;
    }

    function renderModalDefinitionList(sectionName, selector, items) {
      var section = modal && modal.querySelector('[data-tm-rotation-r03-modal-section="' + sectionName + '"]');
      var list = modal && modal.querySelector(selector);
      var visibleItems = items.filter(function (item) {
        return item.value;
      });

      if (!section || !list) {
        return;
      }

      list.innerHTML = '';

      visibleItems.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'tm-rotation-r03-builder__modal-definition';

        var term = document.createElement('dt');
        term.textContent = item.label;

        var value = document.createElement('dd');
        value.textContent = item.value;

        row.appendChild(term);
        row.appendChild(value);
        list.appendChild(row);
      });

      section.hidden = !visibleItems.length;
    }

    function renderModalChips(items) {
      var section = modal && modal.querySelector('[data-tm-rotation-r03-modal-section="best-for"]');
      var list = modal && modal.querySelector('[data-tm-rotation-r03-modal-best-for]');

      if (!section || !list) {
        return;
      }

      list.innerHTML = '';

      items.filter(Boolean).forEach(function (item) {
        var chip = document.createElement('span');
        chip.textContent = item;
        list.appendChild(chip);
      });

      section.hidden = !list.children.length;
    }

    function renderModalVariantControls(card) {
      if (!modal || !card) {
        return;
      }

      var data = getCardData(card);
      var available = getAvailableVariants(card);
      var control = modal.querySelector('[data-tm-rotation-r03-modal-variant-control]');
      var select = modal.querySelector('[data-tm-rotation-r03-modal-variant-select]');
      var variant = modal.querySelector('[data-tm-rotation-r03-modal-variant]');
      var price = modal.querySelector('[data-tm-rotation-r03-modal-price]');
      var showSelect = showModalVariant && available.length > 1;
      var showLabel = showModalVariant && !showSelect && !!data.variantTitle;

      if (control) {
        control.hidden = !showSelect && !showLabel;
      }

      if (select) {
        select.innerHTML = '';

        available.forEach(function (item) {
          var option = document.createElement('option');
          option.value = item.id;
          option.textContent = isMeaningfulVariantTitle(item.title) ? item.title : 'Default';
          option.selected = String(item.id) === String(data.variantId);
          select.appendChild(option);
        });

        select.hidden = !showSelect;
      }

      if (variant) {
        variant.textContent = data.variantTitle;
        variant.hidden = !showLabel;
      }

      if (price) {
        price.textContent = data.price;
        price.hidden = !showModalPrice || !data.price;
      }
    }

    function updateUI() {
      var count = selected.length;
      var countText = count + (count === 1 ? ' selected' : ' selected');
      var tierMessage = getTierMessage(count);
      var ctaLabel = getCtaLabel(count);
      var canAdd = count > 0;

      setTextAll('[data-tm-rotation-r03-count]', countText);
      setTextAll('[data-tm-rotation-r03-tier-message]', tierMessage);

      builder.querySelectorAll(SELECTORS.r03Add).forEach(function (button) {
        button.textContent = isAdding ? 'Adding...' : ctaLabel;
        button.disabled = isAdding || !canAdd;
        button.setAttribute('aria-busy', isAdding ? 'true' : 'false');
      });

      builder.querySelectorAll(SELECTORS.r03MobileReview).forEach(function (button) {
        button.textContent = isAdding ? 'Adding...' : getMobileReviewLabel(count);
        button.disabled = isAdding || !canAdd;
        button.setAttribute('aria-busy', isAdding ? 'true' : 'false');
        button.setAttribute('aria-expanded', mobileDrawer && !mobileDrawer.hidden ? 'true' : 'false');
      });

      builder.querySelectorAll('[data-tm-rotation-r03-complete-helper]').forEach(function (item) {
        item.textContent = completeHelper;
        item.hidden = count < topTier;
      });

      builder.querySelectorAll('[data-tm-rotation-r03-progress]').forEach(function (item) {
        item.style.width = Math.min(100, Math.round((count / topTier) * 100)) + '%';
      });

      builder.querySelectorAll('[data-tm-rotation-r03-tier]').forEach(function (item) {
        var tier = Number(item.getAttribute('data-tm-rotation-r03-tier')) || 0;
        item.classList.toggle('is-unlocked', count >= tier);
      });

      cards.forEach(function (card) {
        var button = card.querySelector(SELECTORS.r03Toggle);
        var indicator = card.querySelector('[data-tm-rotation-r03-selected-indicator]');
        var selectedCard = isSelected(card);
        var disabled = card.classList.contains('is-disabled');

        card.classList.toggle('is-selected', selectedCard);
        card.classList.remove('is-max-blocked');

        if (indicator) {
          indicator.hidden = !selectedCard;
        }

        if (button) {
          button.textContent = selectedCard ? removeLabel : addToRotationLabel;
          button.disabled = disabled;
          button.setAttribute('aria-pressed', selectedCard ? 'true' : 'false');
        }
      });

      renderSelectedList();
      renderSelectedChips();
      updateModalCta();
    }

    function addCard(card) {
      var data = getCardData(card);
      var key = selectedKey(data);
      var existingIndex = selected.findIndex(function (item) {
        return selectedKey(item) === key;
      });

      if (!data.variantId || !key) {
        return;
      }

      if (existingIndex !== -1) {
        selected[existingIndex] = data;
        setError('');
        updateUI();
        return;
      }

      if (selectionLimit > 0 && selected.length >= selectionLimit) {
        setError('Remove a scent before adding another.');
        return;
      }

      selected.push(data);
      setError('');
      updateUI();
    }

    function removeCard(card) {
      var data = getCardData(card);
      var key = selectedKey(data);

      selected = selected.filter(function (item) {
        return selectedKey(item) !== key;
      });

      setError('');
      updateUI();
    }

    function toggleCard(card) {
      if (isSelected(card)) {
        removeCard(card);
      } else {
        addCard(card);
      }
    }

    function updateSelectedVariant(card) {
      var data = getCardData(card);
      var key = selectedKey(data);
      var index = selected.findIndex(function (item) {
        return selectedKey(item) === key;
      });

      if (index === -1) {
        return;
      }

      selected[index] = data;
      setError('');
      updateUI();
    }

    function preloadByHandles(handles) {
      var wanted = handles.map(normalize).filter(Boolean);

      selected = [];

      wanted.forEach(function (handle) {
        var card = cards.find(function (item) {
          return normalize(item.getAttribute('data-tm-rotation-scent-handle')) === handle;
        });

        if (card && !card.classList.contains('is-disabled')) {
          setCardVariant(card, '');
          addCard(card);
        }
      });

      updateUI();
    }

    function openDetails(card) {
      if (!modal || !modalPanel) {
        return;
      }

      var data = getCardData(card);

      activeModalCard = card;
      lastFocused = document.activeElement;

      var title = data.detailTitle || data.title;
      var modalImage = isMobileViewport()
        ? data.mobileModalImage || data.modalImage || data.mobileImage || data.image
        : data.modalImage || data.mobileModalImage || data.image || data.mobileImage;
      var image = modal.querySelector('[data-tm-rotation-r03-modal-image]');
      var placeholder = modal.querySelector('[data-tm-rotation-r03-modal-placeholder]');
      var placeholderText = modal.querySelector('[data-tm-rotation-r03-modal-placeholder-text]');
      var smellsLike = data.modalSmellsLike;
      var view = modal.querySelector('[data-tm-rotation-r03-modal-view]');

      if (sameCleanText(smellsLike, data.modalLead)) {
        smellsLike = '';
      }

      if (image) {
        if (modalImage) {
          image.src = modalImage;
          image.alt = title;
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.alt = '';
          image.hidden = true;
        }
      }

      if (placeholder) {
        placeholder.hidden = !!modalImage;
      }

      if (placeholderText) {
        placeholderText.textContent = (title || '?').slice(0, 1).toUpperCase();
      }

      setModalText('[data-tm-rotation-r03-modal-role]', data.modalEyebrow || data.role || 'THE MAN PARFUM');
      setModalText('[data-tm-rotation-r03-modal-title]', title);
      setModalText('[data-tm-rotation-r03-modal-profile]', data.modalProfile || data.notes);
      setModalText('[data-tm-rotation-r03-modal-lead]', data.modalLead);
      setModalSection('smells', smellsLike);

      renderModalDefinitionList('performance', '[data-tm-rotation-r03-modal-performance]', [
        { label: 'Skin', value: data.modalSkinPerformance },
        { label: 'Clothes', value: data.modalClothesPerformance },
        { label: 'Projection', value: data.modalProjection }
      ]);

      renderModalDefinitionList('notes', '[data-tm-rotation-r03-modal-notes]', [
        { label: 'Top', value: data.modalTopNotes },
        { label: 'Middle', value: data.modalMiddleNotes },
        { label: 'Base', value: data.modalBaseNotes }
      ]);

      setModalSection('best-worn', data.modalBestWorn || data.bestFor);
      renderModalChips(data.modalBestForChips.length ? data.modalBestForChips : splitList(data.bestFor));

      renderModalVariantControls(card);

      if (view) {
        view.textContent = viewProductLabel;
        view.href = data.productUrl || '#';
        view.hidden = !showViewProduct || !data.productUrl;
      }

      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tm-rotation-r03-modal-open');
      updateModalCta();
      modalPanel.focus();
    }

    function closeDetails() {
      if (!modal || modal.hidden) {
        return;
      }

      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tm-rotation-r03-modal-open');
      activeModalCard = null;

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    function openMobileDrawer() {
      if (!mobileDrawer || !mobileDrawerPanel) {
        return;
      }

      mobileDrawerLastFocused = document.activeElement;
      mobileDrawer.hidden = false;
      mobileDrawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('tm-rotation-r03-drawer-open');
      updateUI();
      mobileDrawerPanel.focus();
    }

    function closeMobileDrawer() {
      if (!mobileDrawer || mobileDrawer.hidden) {
        return;
      }

      mobileDrawer.hidden = true;
      mobileDrawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('tm-rotation-r03-drawer-open');
      updateUI();

      if (mobileDrawerLastFocused && typeof mobileDrawerLastFocused.focus === 'function') {
        mobileDrawerLastFocused.focus();
      }
    }

    function updateFilteredCount(visibleCount) {
      var count = builder.querySelector('[data-tm-rotation-r03-filtered-count]');

      if (!count) {
        return;
      }

      if (activeFilter === 'all') {
        count.hidden = true;
        count.textContent = '';
        return;
      }

      count.textContent = visibleCount + (visibleCount === 1 ? ' scent shown' : ' scents shown');
      count.hidden = false;
    }

    function applyFilter(nextFilter) {
      var visibleCount = 0;
      var visibleKeys = {};

      activeFilter = normalize(nextFilter) || 'all';

      builder.querySelectorAll(SELECTORS.r03Filter).forEach(function (button) {
        var active = normalize(button.getAttribute('data-tm-rotation-r03-filter')) === activeFilter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      cards.forEach(function (card) {
        var tags = splitList(card.getAttribute('data-tm-rotation-scent-tags')).map(normalize);
        var visible = activeFilter === 'all' || tags.indexOf(activeFilter) !== -1;
        var visibleKey = card.getAttribute('data-tm-rotation-scent-handle') || card.getAttribute('data-tm-rotation-variant-id') || '';

        if (visible && visibleKey) {
          if (visibleKeys[visibleKey]) {
            visible = false;
          } else {
            visibleKeys[visibleKey] = true;
          }
        }

        card.hidden = !visible;

        if (visible) {
          visibleCount += 1;
        }
      });

      updateFilteredCount(visibleCount);
    }

    document.addEventListener('tm-rotation:activate-filter', function (event) {
      var detail = event.detail || {};
      var targetSelector = detail.targetSelector || detail.target || '';
      var filter = detail.filter || '';

      if (targetSelector) {
        var target = findBySelector(targetSelector);

        if (target && target !== builder) {
          return;
        }
      }

      if (!filter) {
        return;
      }

      applyFilter(filter);
    });

    builder.addEventListener('click', function (event) {
      var toggle = event.target.closest(SELECTORS.r03Toggle);
      var details = event.target.closest(SELECTORS.r03Details);
      var add = event.target.closest(SELECTORS.r03Add);
      var mobileReview = event.target.closest(SELECTORS.r03MobileReview);
      var remove = event.target.closest('[data-tm-rotation-r03-remove]');
      var filter = event.target.closest(SELECTORS.r03Filter);
      var mobileDrawerClose = event.target.closest(SELECTORS.r03MobileDrawerClose);

      if (toggle && builder.contains(toggle)) {
        event.preventDefault();
        markRotationContext();
        toggleCard(toggle.closest(SELECTORS.r03Card));
      }

      if (details && builder.contains(details)) {
        event.preventDefault();
        openDetails(details.closest(SELECTORS.r03Card));
      }

      if (remove && builder.contains(remove)) {
        markRotationContext();
        selected = selected.filter(function (item) {
          return selectedKey(item) !== remove.getAttribute('data-tm-rotation-r03-remove');
        });
        setError('');
        updateUI();
      }

      if (filter && builder.contains(filter)) {
        applyFilter(filter.getAttribute('data-tm-rotation-r03-filter'));
      }

      if (mobileReview && builder.contains(mobileReview)) {
        event.preventDefault();
        markRotationContext();
        openMobileDrawer();
      }

      if (add && builder.contains(add)) {
        event.preventDefault();
        markRotationContext();
        addSelectedToCart();
      }

      if (mobileDrawerClose && builder.contains(mobileDrawerClose)) {
        event.preventDefault();
        closeMobileDrawer();
      }
    });

    builder.addEventListener('change', function (event) {
      var select = event.target.closest('[data-tm-rotation-r03-variant-select]');

      if (!select || !builder.contains(select)) {
        return;
      }

      var card = select.closest(SELECTORS.r03Card);

      if (!card) {
        return;
      }

      setCardVariant(card, select.value);

      if (isSelected(card)) {
        updateSelectedVariant(card);
      }

      if (activeModalCard === card) {
        renderModalVariantControls(card);
      }
    });

    if (modal) {
      modal.addEventListener('click', function (event) {
        if (event.target.closest('[data-tm-rotation-r03-modal-close]')) {
          closeDetails();
        }

        if (event.target.closest('[data-tm-rotation-r03-modal-toggle]') && activeModalCard) {
          toggleCard(activeModalCard);
          updateModalCta();
        }
      });

      modal.addEventListener('change', function (event) {
        var select = event.target.closest('[data-tm-rotation-r03-modal-variant-select]');

        if (!select || !activeModalCard) {
          return;
        }

        setCardVariant(activeModalCard, select.value);

        if (isSelected(activeModalCard)) {
          updateSelectedVariant(activeModalCard);
        } else {
          updateModalCta();
        }

        renderModalVariantControls(activeModalCard);
      });

      modal.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeDetails();
          return;
        }

        if (event.key !== 'Tab') {
          return;
        }

        var focusable = Array.prototype.slice.call(modal.querySelectorAll(focusableSelector))
          .filter(function (item) {
            return item.offsetParent !== null;
          });

        if (!focusable.length) {
          return;
        }

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    if (mobileDrawer) {
      mobileDrawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeMobileDrawer();
          return;
        }

        if (event.key !== 'Tab') {
          return;
        }

        var focusable = Array.prototype.slice.call(mobileDrawer.querySelectorAll(focusableSelector))
          .filter(function (item) {
            return item.offsetParent !== null;
          });

        if (!focusable.length) {
          return;
        }

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    function addSelectedToCart() {
      if (isAdding || selected.length <= 0) {
        return;
      }

      markRotationContext();

      var variantIds = selected.map(function (item) {
        return item.variantId;
      }).filter(Boolean);

      if (!variantIds.length) {
        setError('Selected scents are currently unavailable.');
        return;
      }

      isAdding = true;
      setError('');
      updateUI();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: variantIds.map(function (id) {
            return {
              id: Number(id),
              quantity: 1
            };
          })
        })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().catch(function () {
              return {};
            }).then(function (payload) {
              throw new Error(payload.description || payload.message || 'Unable to add this rotation.');
            });
          }

          return response.json();
        })
        .then(function (addResponse) {
          return fetch('/cart.js', {
            headers: {
              'Accept': 'application/json'
            }
          }).then(function (response) {
            if (!response.ok) {
              return addResponse;
            }

            return response.json();
          });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('product-form:cart:update', {
            bubbles: true,
            detail: {
              cart: cart
            }
          }));

          builder.dispatchEvent(new CustomEvent('tm-rotation:builder:add', {
            bubbles: true,
            detail: {
              handles: selected.map(function (item) {
                return item.handle;
              }),
              variantIds: variantIds,
              cart: cart
            }
          }));

          closeMobileDrawer();

          if (!openCartDrawer()) {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          setError(error.message || 'Unable to add this rotation.');
        })
        .finally(function () {
          isAdding = false;
          updateUI();
        });
    }

    document.addEventListener('tm-rotation:edit-rotation', function (event) {
      var handles = event.detail && event.detail.handles ? event.detail.handles : [];

      if (!handles.length) {
        return;
      }

      preloadByHandles(handles);
      scrollToHash('#tm-rotation-r03', false);

      if (isMobileViewport() && selected.length >= min) {
        window.setTimeout(openMobileDrawer, 320);
      }
    });

    initializeVariantControls();
    applyFilter(activeFilter);
    updateUI();
  }

  document.querySelectorAll(SELECTORS.r03Builder).forEach(initR03Builder);

  function initR04Finder(finder) {
    var tabs = Array.prototype.slice.call(finder.querySelectorAll(SELECTORS.r04Tab));
    var panels = Array.prototype.slice.call(finder.querySelectorAll(SELECTORS.r04Panel));
    var targetSelector = finder.getAttribute('data-tm-rotation-r04-target') || '#tm-rotation-r03';
    var smoothScroll = finder.getAttribute('data-tm-rotation-r04-smooth-scroll') !== 'false';

    if (!tabs.length || !panels.length) {
      return;
    }

    function normalizeMoment(value) {
      return (value || '').trim().toLowerCase();
    }

    function setActive(moment) {
      var nextMoment = normalizeMoment(moment);
      var activePanel = null;

      tabs.forEach(function (tab) {
        var active = normalizeMoment(tab.getAttribute('data-tm-rotation-r04-moment')) === nextMoment;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var active = normalizeMoment(panel.getAttribute('data-tm-rotation-r04-moment')) === nextMoment;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;

        if (active) {
          activePanel = panel;
        }
      });

      if (!activePanel && panels[0]) {
        setActive(panels[0].getAttribute('data-tm-rotation-r04-moment'));
      }
    }

    finder.addEventListener('click', function (event) {
      var tab = event.target.closest(SELECTORS.r04Tab);
      var cta = event.target.closest(SELECTORS.r04Cta);

      if (tab && finder.contains(tab)) {
        event.preventDefault();
        setActive(tab.getAttribute('data-tm-rotation-r04-moment'));
        return;
      }

      if (cta && finder.contains(cta)) {
        event.preventDefault();

        document.dispatchEvent(new CustomEvent('tm-rotation:activate-filter', {
          detail: {
            filter: cta.getAttribute('data-tm-rotation-r04-filter') || '',
            targetSelector: targetSelector
          }
        }));

        scrollToHash(targetSelector, false, smoothScroll ? 'smooth' : 'auto');
      }
    });

    finder.addEventListener('keydown', function (event) {
      var tab = event.target.closest(SELECTORS.r04Tab);

      if (!tab || !finder.contains(tab)) {
        return;
      }

      var currentIndex = tabs.indexOf(tab);
      var nextIndex = currentIndex;

      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        nextIndex = currentIndex + 1 >= tabs.length ? 0 : currentIndex + 1;
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        nextIndex = currentIndex - 1 < 0 ? tabs.length - 1 : currentIndex - 1;
      } else if (event.key === 'Home') {
        nextIndex = 0;
      } else if (event.key === 'End') {
        nextIndex = tabs.length - 1;
      } else {
        return;
      }

      event.preventDefault();
      tabs[nextIndex].focus();
      setActive(tabs[nextIndex].getAttribute('data-tm-rotation-r04-moment'));
    });

    if (!finder.querySelector(SELECTORS.r04Panel + '.is-active')) {
      setActive(tabs[0].getAttribute('data-tm-rotation-r04-moment'));
    }
  }

  document.querySelectorAll(SELECTORS.r04Finder).forEach(initR04Finder);

  function initR05Focus(section) {
    var targetSelector = section.getAttribute('data-tm-rotation-r05-target') || '#tm-rotation-r03';
    var defaultFilter = section.getAttribute('data-tm-rotation-r05-filter') || 'Fresh';
    var cardClickEnabled = section.getAttribute('data-tm-rotation-r05-card-click') !== 'false';
    var scroller = section.querySelector(SELECTORS.r05Scroller);
    var cards = scroller ? Array.prototype.slice.call(scroller.querySelectorAll(SELECTORS.r05Card)) : [];
    var dots = Array.prototype.slice.call(section.querySelectorAll(SELECTORS.r05Dot));

    function handoff(filter) {
      document.dispatchEvent(new CustomEvent('tm-rotation:activate-filter', {
        detail: {
          filter: filter || defaultFilter,
          targetSelector: targetSelector
        }
      }));

      scrollToHash(targetSelector, false);
    }

    function setActiveDot(index) {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function getNearestCardIndex() {
      if (!scroller || !cards.length) {
        return 0;
      }

      var left = scroller.scrollLeft;
      var nearestIndex = 0;
      var nearestDistance = Infinity;

      cards.forEach(function (card, index) {
        var distance = Math.abs(card.offsetLeft - left);

        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });

      return nearestIndex;
    }

    function scrollCard(direction) {
      if (!scroller || !cards.length) {
        return;
      }

      var currentIndex = getNearestCardIndex();
      var nextIndex = Math.max(0, Math.min(cards.length - 1, currentIndex + direction));

      scroller.scrollTo({
        left: cards[nextIndex].offsetLeft,
        behavior: 'smooth'
      });

      setActiveDot(nextIndex);
    }

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest(SELECTORS.r05Trigger);
      var card = event.target.closest(SELECTORS.r05Card);
      var prev = event.target.closest(SELECTORS.r05Prev);
      var next = event.target.closest(SELECTORS.r05Next);
      var dot = event.target.closest(SELECTORS.r05Dot);

      if (trigger && section.contains(trigger)) {
        event.preventDefault();
        handoff(trigger.getAttribute('data-tm-rotation-r05-filter'));
        return;
      }

      if (prev && section.contains(prev)) {
        event.preventDefault();
        scrollCard(-1);
        return;
      }

      if (next && section.contains(next)) {
        event.preventDefault();
        scrollCard(1);
        return;
      }

      if (dot && section.contains(dot) && scroller && cards.length) {
        var index = Number(dot.getAttribute('data-tm-rotation-r05-dot')) || 0;
        var cardForDot = cards[Math.max(0, Math.min(cards.length - 1, index))];

        event.preventDefault();

        if (cardForDot) {
          scroller.scrollTo({
            left: cardForDot.offsetLeft,
            behavior: 'smooth'
          });
          setActiveDot(cards.indexOf(cardForDot));
        }

        return;
      }

      if (card && section.contains(card)) {
        event.preventDefault();

        if (cardClickEnabled) {
          handoff(card.getAttribute('data-tm-rotation-r05-filter'));
        }
      }
    });

    if (scroller && dots.length) {
      scroller.addEventListener('scroll', function () {
        requestFrame(function () {
          setActiveDot(getNearestCardIndex());
        });
      }, { passive: true });
    }
  }

  document.querySelectorAll(SELECTORS.r05Focus).forEach(initR05Focus);

  function initR06WhyRotation(section) {
    section.addEventListener('click', function (event) {
      var cta = event.target.closest(SELECTORS.r06Cta);

      if (!cta || !section.contains(cta)) {
        return;
      }

      var targetSelector = cta.getAttribute('data-tm-rotation-r06-target') || '';
      var filter = cta.getAttribute('data-tm-rotation-r06-filter') || '';

      event.preventDefault();

      if (filter) {
        document.dispatchEvent(new CustomEvent('tm-rotation:activate-filter', {
          detail: {
            filter: filter,
            targetSelector: targetSelector
          }
        }));
      }

      scrollToHash(targetSelector, false);
    });
  }

  document.querySelectorAll(SELECTORS.r06WhyRotation).forEach(initR06WhyRotation);

  function initR07SavingsExplainer(section) {
    section.addEventListener('click', function (event) {
      var cta = event.target.closest(SELECTORS.r07Cta);

      if (!cta || !section.contains(cta)) {
        return;
      }

      event.preventDefault();
      scrollToHash(cta.getAttribute('data-tm-rotation-r07-target') || '', false);
    });
  }

  document.querySelectorAll(SELECTORS.r07SavingsExplainer).forEach(initR07SavingsExplainer);

  function initR08ProofReviews(section) {
    section.addEventListener('click', function (event) {
      var cta = event.target.closest(SELECTORS.r08Cta);

      if (!cta || !section.contains(cta)) {
        return;
      }

      event.preventDefault();
      scrollToHash(cta.getAttribute('data-tm-rotation-r08-target') || '', false);
    });
  }

  document.querySelectorAll(SELECTORS.r08ProofReviews).forEach(initR08ProofReviews);

  function initR09Faq(section) {
    var allowMultiple = section.getAttribute('data-tm-rotation-r09-allow-multiple') === 'true';

    function setItemOpen(item, open) {
      var trigger = item.querySelector(SELECTORS.r09Trigger);
      var panel = item.querySelector(SELECTORS.r09Panel);

      if (!trigger || !panel) {
        return;
      }

      if (open) {
        panel.hidden = false;
      }

      item.setAttribute('data-open', open ? 'true' : 'false');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

      if (!open) {
        window.setTimeout(function () {
          if (item.getAttribute('data-open') !== 'true') {
            panel.hidden = true;
          }
        }, 230);
      }
    }

    section.addEventListener('click', function (event) {
      var cta = event.target.closest(SELECTORS.r09Cta);
      var trigger = event.target.closest(SELECTORS.r09Trigger);

      if (cta && section.contains(cta)) {
        event.preventDefault();
        scrollToHash(cta.getAttribute('data-tm-rotation-r09-target') || '', false);
        return;
      }

      if (!trigger || !section.contains(trigger)) {
        return;
      }

      var item = trigger.closest(SELECTORS.r09Item);

      if (!item) {
        return;
      }

      event.preventDefault();

      var shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';

      if (shouldOpen && !allowMultiple) {
        section.querySelectorAll(SELECTORS.r09Item).forEach(function (otherItem) {
          if (otherItem !== item) {
            setItemOpen(otherItem, false);
          }
        });
      }

      setItemOpen(item, shouldOpen);
    });
  }

  document.querySelectorAll(SELECTORS.r09Faq).forEach(initR09Faq);

  function initR10FinalCta(section) {
    section.addEventListener('click', function (event) {
      var cta = event.target.closest(SELECTORS.r10Cta);

      if (!cta || !section.contains(cta)) {
        return;
      }

      event.preventDefault();
      handoffToRotationTarget(
        cta.getAttribute('data-tm-rotation-r10-target') || '',
        cta.getAttribute('data-tm-rotation-r10-filter') || ''
      );
    });
  }

  document.querySelectorAll(SELECTORS.r10FinalCta).forEach(initR10FinalCta);

  function initR10StickyCta(sticky) {
    var trigger = sticky.querySelector(SELECTORS.r10StickyTrigger);
    var mobileMedia = window.matchMedia('(max-width: 989px)');
    var ticking = false;

    function hasActiveFormInteraction() {
      var active = document.activeElement;

      return active && active.matches && active.matches('input, select, textarea');
    }

    function setMobileSummaryVisible(summary, visible) {
      if (!summary) {
        return;
      }

      summary.hidden = !visible;
      summary.toggleAttribute('data-tm-rotation-sticky-visible', visible);
    }

    function setR10StickyVisible(visible) {
      sticky.hidden = !visible;
      sticky.toggleAttribute('data-tm-rotation-sticky-visible', visible);
    }

    function getStickyState() {
      var builder = document.querySelector(SELECTORS.r03Builder);
      var finalCta = document.querySelector(SELECTORS.r10FinalCta);
      var footer = document.querySelector('.site-footer, footer');
      var builderSummary = document.querySelector(SELECTORS.r03MobileSummary);
      var mobileDrawerOpen = document.documentElement.classList.contains('tm-rotation-r03-drawer-open');
      var modalOpen = document.documentElement.classList.contains('tm-rotation-r03-modal-open');
      var cartOpen = isOfficialCartSurfaceOpen();
      var mobile = mobileMedia.matches;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var builderRect = builder ? builder.getBoundingClientRect() : null;
      var r03Relevant = false;
      var scrolledPastBuilder = false;
      var finalCtaVisible = false;
      var footerConflict = false;
      var r03BarVisible = false;
      var r10Visible = false;

      if (builderRect) {
        r03Relevant = builderRect.top < viewportHeight - 24 && builderRect.bottom > 180;
        scrolledPastBuilder = builderRect.bottom <= 180;
      }

      if (finalCta) {
        finalCtaVisible = isRectInViewportRange(finalCta.getBoundingClientRect(), 24, 24);
      }

      if (footer) {
        footerConflict = footer.getBoundingClientRect().top < viewportHeight + 96;
      }

      if (mobile && builderSummary && !modalOpen && !cartOpen && (r03Relevant || mobileDrawerOpen)) {
        r03BarVisible = true;
      }

      if (
        mobile &&
        builder &&
        trigger &&
        scrolledPastBuilder &&
        !r03Relevant &&
        !r03BarVisible &&
        !mobileDrawerOpen &&
        !modalOpen &&
        !cartOpen &&
        !hasActiveFormInteraction() &&
        !finalCtaVisible &&
        !footerConflict
      ) {
        r10Visible = true;
      }

      return {
        builderSummary: builderSummary,
        r03BarVisible: r03BarVisible,
        r10Visible: r10Visible
      };
    }

    function update() {
      var state = getStickyState();

      setMobileSummaryVisible(state.builderSummary, state.r03BarVisible);
      setR10StickyVisible(state.r10Visible);
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;
      update();
    }

    if (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        handoffToRotationTarget(
          trigger.getAttribute('data-tm-rotation-r10-target') || '',
          trigger.getAttribute('data-tm-rotation-r10-filter') || ''
        );
      });
    }

    setR10StickyVisible(false);
    setMobileSummaryVisible(document.querySelector(SELECTORS.r03MobileSummary), false);
    window.addEventListener('scroll', requestUpdate, { passive: true });
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    window.addEventListener('orientationchange', requestUpdate);
    document.addEventListener('focusin', requestUpdate);
    document.addEventListener('focusout', requestUpdate);
    document.addEventListener('cart:open', requestUpdate);
    document.addEventListener('drawerOpen', requestUpdate);
    document.addEventListener('drawerClose', requestUpdate);
    document.addEventListener('tm-rotation:activate-filter', requestUpdate);
    document.addEventListener('tm-rotation:sticky-state-change', requestUpdate);

    if (typeof window.setInterval === 'function') {
      window.setInterval(requestUpdate, 250);
    }

    if (window.MutationObserver) {
      var stateObserver = new MutationObserver(requestUpdate);
      stateObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: ['class']
      });

      if (document.body) {
        stateObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class']
        });
      }

      document.querySelectorAll('#CartDrawer, [data-cart-drawer], .cart-drawer, .drawer--right, [data-tm-rotation-r03-mobile-drawer], [data-tm-rotation-r03-modal]').forEach(function (item) {
        stateObserver.observe(item, {
          attributes: true,
          attributeFilter: ['class', 'hidden', 'aria-hidden', 'style']
        });
      });
    }

    requestUpdate();
  }

  function initR10StickyCtas() {
    document.querySelectorAll(SELECTORS.r10Sticky).forEach(function (sticky) {
      if (sticky.hasAttribute('data-tm-rotation-r10-sticky-ready')) {
        return;
      }

      sticky.setAttribute('data-tm-rotation-r10-sticky-ready', 'true');
      initR10StickyCta(sticky);
    });
  }

  initR10StickyCtas();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initR10StickyCtas, { once: true });
  } else {
    initR10StickyCtas();
  }

  window.addEventListener('load', initR10StickyCtas);

  window.addEventListener('load', function () {
    var featured = document.querySelector('[data-tm-rotation-featured-card]');
    var scroller = featured && featured.closest('[data-tm-rotation-r02-scroller]');

    if (!featured || !scroller || !window.matchMedia('(max-width: 989px)').matches) {
      return;
    }

    var left = featured.offsetLeft - (scroller.clientWidth - featured.clientWidth) / 2;

    scroller.scrollLeft = Math.max(0, left);
  });

  var ticking = false;

  window.addEventListener('scroll', function () {
    if (ticking) {
      return;
    }

    ticking = true;
    requestFrame(function () {
      refreshActiveFromScroll();
      ticking = false;
    });
  }, { passive: true });

  window.addEventListener('load', function () {
    if (window.location.hash) {
      window.setTimeout(function () {
        scrollToHash(window.location.hash, false);
      }, 80);
    }

    refreshActiveFromScroll();
  });

  document.querySelectorAll(SELECTORS.drawer).forEach(function (drawer) {
    var openButtons = document.querySelectorAll(SELECTORS.drawerOpen);
    var closeButtons = drawer.querySelectorAll(SELECTORS.drawerClose);
    var focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var lastFocused = null;

    function getFocusable() {
      return Array.prototype.slice.call(drawer.querySelectorAll(focusableSelector))
        .filter(function (item) {
          return item.offsetParent !== null;
        });
    }

    function openDrawer() {
      lastFocused = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';

      var focusable = getFocusable();

      if (focusable.length) {
        focusable[0].focus();
      }
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';

      if (lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus();
      }
    }

    openButtons.forEach(function (button) {
      button.addEventListener('click', openDrawer);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    drawer.addEventListener('click', function (event) {
      if (event.target.closest('[data-tm-rotation-drawer-link]')) {
        closeDrawer();
      }
    });

    drawer.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeDrawer();
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusable = getFocusable();

      if (!focusable.length) {
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
})();
